import React from 'react';

import ReactDOM from 'react-dom/client';

import '@/index.css';

import { AuthProvider } from '@/contexts/auth';
import { Toaster } from '@/components/ui/toaster';
import { GTMProvider } from '@/components/GTMProvider';
import { PostHogProvider } from '@/components/PostHogProvider';
import { RouterWithGTM } from '@/components/RouterWithGTM';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <PostHogProvider>
    <GTMProvider>
      <AuthProvider>
        <RouterWithGTM />
        <Toaster />
      </AuthProvider>
    </GTMProvider>
  </PostHogProvider>
);
